import { observable } from "mobx";
import http from 'libs/http';

class Store {
  @observable records = [];
  @observable company = [];
  @observable record = {};
  @observable isFetching = false;
  @observable formVisible = false;

  @observable f_name;
  @observable f_company;

  fetchRecords = () => {
    this.isFetching = true;
    http.get('/api/student/work/')
      .then((res) => {
        this.records = res;
      })
      .finally(() => this.isFetching = false)
  };

  showForm = (info = {}) => {
    this.formVisible = true;
    this.record = info;
    console.log('this.record', this.record);
  }
}

export default new Store()
